<template>
  <div class="entry">
    <EntryHero :title="entry.title" :cover="entry.image"></EntryHero>
    <EntryContent :content="entry.content"></EntryContent>
  </div>
</template>

<script>
import EntryHero from "../components/EntryHero";
import EntryContent from "../components/EntryContent";
import { db } from "../services/firebase";

const news = db.collection("news");

export default {
  name: "entry",
  components: {
    EntryHero,
    EntryContent
  },
  data() {
    return {
      entry: {
        title: "",
        image: "",
        content: ""
      }
    };
  },
  async created() {
    await this.$bind("entry", news.doc(this.$route.params.slug));
  },
  mounted() {
    document.getElementById("main").scrollTo(0, 0); // go to top
  }
};
</script>

<style scoped lang="sass">
.entry
  /**/
</style>
